import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  header: ReactNode;
  facts?: ReactNode;
  analysis?: ReactNode;
  description?: ReactNode;
  notFound?: ReactNode;
  extras?: ReactNode;          // mid-page sections (chips: families, techniques, …)
  documents?: ReactNode;
  cooccurrence?: ReactNode;
}

export default function EntityDetailShell({
  header,
  facts,
  analysis,
  description,
  notFound,
  extras,
  documents,
  cooccurrence,
}: Props) {
  const navigate = useNavigate();
  return (
    <div className="ioc-detail-page entity-detail-page">
      <button className="ioc-detail-back" onClick={() => navigate(-1)}>&larr; Back</button>
      {header}
      {facts}
      {analysis}
      {description}
      {notFound}
      {extras}
      {documents && (
        <div className="ioc-detail-section">
          {documents}
        </div>
      )}
      {cooccurrence && (
        <div className="ioc-detail-section">
          {cooccurrence}
        </div>
      )}
    </div>
  );
}
